import GetRecordingButton from 'components/atoms/getRecordingButton';
import RectangleImageButton from 'components/atoms/rectangleImageButton';
import ReactionView from 'components/molecules/reactionView';
import ShareView from 'components/molecules/shareView';
import {useTheme} from 'contexts/ThemeContext';
import React, {useEffect} from 'react';
import {Image, Platform, Text, TouchableOpacity, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ConferenceBottomMenuProps {
  isMicroActive: boolean;
  isCameraActive: boolean;
  isChatActive: boolean;
  isShareActive: boolean;
  isParticipantsActive: boolean;
  isSmileActive: boolean;
  shouldShowMuteAll: boolean;
  isRecordingRequest: boolean;
  shouldShowUnreadMessageMarker: boolean;
  onMicrophoneButtonPressed: () => void;
  onPressStopShare: () => void;
  onCameraButtonPressed: () => void;
  onShareButtonPressed: () => void;
  onChatButtonPressed: () => void;
  onSmileButtonPressed: () => void;
  onMuteAllButtonPressed: () => void;
  onGetRecordingButtonPressed: () => void;
  onDisconnectButtonPressed: () => void;
  onUsersButtonPressed: () => void;
  onPressReaction: (reaction: string) => void;
  onPressRaiseHand: () => void;
}

const ConferenceBottomMenu = (props: ConferenceBottomMenuProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const activeBackground = theme.colors.purple(1);
  const usualBackground = theme.colors.purple(0.13);

  const ChatButton = (
    <View>
      {props.shouldShowUnreadMessageMarker && (
        <View style={styles.unreadMessageMarker} />
      )}
      <RectangleImageButton
        onPress={props.onChatButtonPressed}
        image={
          props.isChatActive
            ? theme.images.activeChatMessages
            : theme.images.usualChatMessages
        }
        backgroundColor={
          props.isChatActive ? activeBackground : usualBackground
        }
      />
    </View>
  );

  const MuteAll = (
    <TouchableOpacity
      style={styles.muteAllContainer}
      onPress={props.onMuteAllButtonPressed}>
      <Image
        style={styles.muteAllImage}
        source={theme.images.microphoneStateOn}
      />
      <Text style={styles.muteAllText}>{strings.conferenceScreen.muteAll}</Text>
    </TouchableOpacity>
  );

  const Reaction = (
    <ReactionView
      isShown={props.isSmileActive}
      onPressRaiseHand={props.onPressRaiseHand}
      onPressReaction={props.onPressReaction}
    />
  );

  return (
    <View style={styles.container}>
      <View style={styles.buttonsContainer}>
        <RectangleImageButton
          onPress={props.onMicrophoneButtonPressed}
          backgroundColor={
            !props.isMicroActive ? activeBackground : usualBackground
          }
          image={
            props.isMicroActive
              ? theme.images.microphoneStateOn
              : theme.images.microphoneStateOff
          }
        />
        <RectangleImageButton
          onPress={props.onCameraButtonPressed}
          backgroundColor={
            !props.isCameraActive ? activeBackground : usualBackground
          }
          image={
            props.isCameraActive
              ? theme.images.cameraStateOn
              : theme.images.cameraStateOff
          }
        />
        {Platform.OS == 'web' && (
          <RectangleImageButton
            onPress={props.onShareButtonPressed}
            backgroundColor={
              props.isShareActive ? activeBackground : usualBackground
            }
            image={
              props.isShareActive
                ? theme.images.activeShare
                : theme.images.defaultShare
            }>
            {props.isShareActive ? (
              <ShareView onPressStopShare={props.onPressStopShare} />
            ) : undefined}
          </RectangleImageButton>
        )}
        <RectangleImageButton
          backgroundColor={
            props.isSmileActive ? activeBackground : usualBackground
          }
          onPress={props.onSmileButtonPressed}
          image={
            props.isSmileActive
              ? theme.images.activeFaceSmile
              : theme.images.usualFaceSmile
          }>
          {theme.isWebSize ? Reaction : undefined}
        </RectangleImageButton>
        {ChatButton}
        {theme.isWebSize && (
          <RectangleImageButton
            onPress={props.onUsersButtonPressed}
            image={
              props.isParticipantsActive
                ? theme.images.activeUsers
                : theme.images.usualUsers
            }
            backgroundColor={
              props.isParticipantsActive ? activeBackground : usualBackground
            }
          />
        )}
        {theme.isWebSize && props.shouldShowMuteAll && (
          <View style={styles.bottomButtonContainerStyle}>
            {MuteAll}
            {!props.isRecordingRequest && (
              <GetRecordingButton
                onGetRecordingButtonPressed={props.onGetRecordingButtonPressed}
              />
            )}
          </View>
        )}
        {theme.isWebSize && (
          <RectangleImageButton
            image={theme.images.disconnect}
            backgroundColor={theme.colors.red}
            onPress={props.onDisconnectButtonPressed}
          />
        )}
      </View>
      {props.shouldShowMuteAll && !theme.isWebSize && (
        <View style={styles.bottomButtonContainerStyle}>
          {MuteAll}
          {!props.isRecordingRequest && (
            <GetRecordingButton
              onGetRecordingButtonPressed={props.onGetRecordingButtonPressed}
            />
          )}
        </View>
      )}
    </View>
  );
};

export default ConferenceBottomMenu;
